export default "__VITE_ASSET__C2cYW6xP__"